import { useRef } from 'react';
import {
    IconFlyoutMenuButton,
    FlyoutDirection,
    IconButtonTheme,
    IconButtonSize,
    FlyoutMenuButton,
    FlyoutMenuTheme,
} from '@apply/components';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { AuthorizedDrawUserDto } from '@apply/api/src/api/ApplyApi';
import { EditUserButton } from './components/EditUserButton';
import { ResendInviteButton } from './components/ResendInviteButton';
import { DeleteUserButton } from './components/DeleteUserButton';
import { isMobileScreen } from '@apply/ui';
import { FlyoutMenuButtonBorderRadius } from '@apply/components/src/components/controls/FlyoutMenuButtons/FlyoutMenuButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
export interface ActionsButtonProps {
    user: AuthorizedDrawUserDto;
    onRefresh: () => void;
}

export const ActionsButton: React.FC<ActionsButtonProps> = ({ user, onRefresh }) => {
    const mobileScreen = isMobileScreen();
    const menuRef = useRef<HTMLDivElement>(null);

    const closeMenu = () => {
        // Find the details element and close it
        const detailsElement = menuRef.current?.querySelector('details');
        if (detailsElement) {
            detailsElement.open = false;
        }
    };

    const renderItemList = () => {
        return (
            <>
                <ul style={{ textAlign: 'left', display: 'grid', gap: '15px' }}>
                    <li>
                        <EditUserButton authorizedDrawUserId={user.id} onRefresh={onRefresh} onClose={closeMenu} />
                    </li>
                    <li>
                        <ResendInviteButton user={user} onClose={closeMenu} />
                    </li>
                    <li>
                        <DeleteUserButton user={user} onRefresh={onRefresh} onClose={closeMenu} />
                    </li>
                </ul>
            </>
        );
    };

    const renderFlyoutMenuButtonContent = () => {
        return (
            <>
                <div style={{ display: 'flex' }}>
                    <div style={{ paddingRight: '10px' }}>Actions</div>
                    <div>
                        <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <div className='manageUsersByUserTable-actions' ref={menuRef}>
                {!mobileScreen && (
                    <IconFlyoutMenuButton
                        id='userActionButton'
                        direction={FlyoutDirection.Left}
                        theme={IconButtonTheme.DarkBlueActive}
                        size={IconButtonSize.Small}
                        icon={faEllipsis}
                    >
                        {renderItemList()}
                    </IconFlyoutMenuButton>
                )}
                {mobileScreen && (
                    <FlyoutMenuButton
                        id='userActionButton'
                        direction={FlyoutDirection.Right}
                        theme={FlyoutMenuTheme.DarkBlueActive}
                        borderRadius={FlyoutMenuButtonBorderRadius.Small}
                        buttonContent={renderFlyoutMenuButtonContent()}
                        width='100px'
                        height='38px'
                    >
                        {renderItemList()}
                    </FlyoutMenuButton>
                )}
            </div>
        </>
    );
};
